import React, { useState } from 'react';
import * as Mui from '@material-ui/core';
import * as MuiIcons from '@material-ui/icons';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core';

import * as pdvActions from '~/store/modules/pdv/pdv-actions';
import * as authActions from '~/store/modules/auth/auth-actions';
import { getApplicationIsOnline, isWeb } from '~/store/modules/app/app-selectors';

const useStyles = makeStyles(theme => ({
  root: {
    width: 520
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column'
  },

  logo: {
    color: theme.palette.primary.main,
    fontSize: '62px',
    '& > span': {
      fontWeight: 300,
      color: theme.palette.text.primary
    }
  }
}));

const ModalTrocaFilial = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { loading, empresa, filiais } = useSelector(state => state.auth);
  const isOnline = useSelector(getApplicationIsOnline());
  const [filialSelecionada, setFilialSelecionada] = useState(empresa ?? 0);

  const { showModalTrocaFilial } = useSelector(state => state.pdv);

  const handleClose = () => {
    dispatch(pdvActions.setShowModalTrocaFilial({ show: false }));
  };

  const handleSubmit = async (filialSelecionada) => {
    dispatch(authActions.chooseFilial({
      filialSelecionada: filialSelecionada ?? null
    }));
  }

  return (
    <Mui.Dialog
      open={showModalTrocaFilial?.show}
      onKeyDown={key => {
        if (key.code === 'Escape') {
          handleClose();
        }
      }}
      PaperComponent={Mui.Paper}
      maxWidth={'lg'}
    >
      <Mui.DialogTitle>
        <Mui.AppBar color="primary" position="static">
          <Mui.Toolbar>

            <Mui.Box style={{ minWidth: 180 }}>
              <Mui.Typography variant="h5" style={{ textTransform: 'upperCase' }}>
                Trocar Filial
              </Mui.Typography>
            </Mui.Box>

            <Mui.Box flexGrow={1} />

            <Mui.IconButton color="inherit" onClick={handleClose} aria-label="close">
              <MuiIcons.Close />
            </Mui.IconButton>

          </Mui.Toolbar>
        </Mui.AppBar>{' '}
      </Mui.DialogTitle>

      <Mui.DialogContent dividers style={{ minWidth: 640 }}>
        <Mui.Card className={classes.root} style={{ margin: 'auto' }}>
          <Mui.CardContent>
            <Mui.Box flexGrow={1} mt={3} className={classes.cardContent}>
              {filiais?.length > 0 ? (
                <>
                  <Mui.FormControl variant="outlined" fullWidth>
                    <Mui.InputLabel id="filial-selecionada-select-outlined-label">
                      Filiais de acesso
                    </Mui.InputLabel>
                    <Mui.Select
                      labelId="filial-selecionada-select-outlined-label"
                      id="filial-selecionada-select-outlined"
                      value={filialSelecionada}
                      label="Filiais de acesso"
                      fullWidth
                      disabled={loading}
                      renderValue={filial => filial?.fantasia}
                    >
                      {filiais?.map(filial => (
                        <Mui.MenuItem
                          key={filial._id}
                          value={filial}
                          onClick={event => {
                            event.persist();
                            setFilialSelecionada(filial);
                          }}
                          disabled={!isWeb && !isOnline && !filial.permiteOffline}
                        >
                          {filial?.fantasia}
                          {'  '} ( <small>{filial?.cnpj}</small> )
                        </Mui.MenuItem>
                      ))}
                    </Mui.Select>
                  </Mui.FormControl>
                </>
              ) : (
                <Mui.Typography variant="h5" style={{ textTransform: 'upperCase' }}>
                  Nenhuma filial encontrada
                </Mui.Typography>
              )}

              <Mui.Box mt={2}>
                <Mui.Button
                  color="primary"
                  disabled={loading}
                  fullWidth
                  size="large"
                  type="submit"
                  onClick={() => handleSubmit(filialSelecionada)}
                  variant="contained"
                  tabIndex={3}
                >
                  {loading ? (
                    <>
                      <Mui.CircularProgress size={24} style={{ marginRight: 12 }} />
                      <Mui.Typography variant="span">Carregando...</Mui.Typography>
                    </>
                  ) : (
                    <>
                      <Mui.Typography variant="span">{'Acessar'}</Mui.Typography>
                    </>
                  )}
                </Mui.Button>
              </Mui.Box>
            </Mui.Box>
          </Mui.CardContent>
        </Mui.Card>
      </Mui.DialogContent>
      <Mui.DialogActions>
        <Mui.Button onClick={handleClose}>
          <MuiIcons.Close />
          <Mui.Typography variant="span" style={{ paddingLeft: 8 }}>
            CANCELAR (ESC)
          </Mui.Typography>
        </Mui.Button>
      </Mui.DialogActions>
    </Mui.Dialog>
  );
};

export default ModalTrocaFilial;
